import { createAction } from '@reduxjs/toolkit';

const TRACKING = 'TRACKING';

export const log = createAction<any>(`${TRACKING}/log`);
export const logError = createAction<any>(`${TRACKING}/logError`);
